<div class="modal-overlay">
  <div class="modal-container">
    <!-- Close Button -->
    <button (click)="closeModal()" class="close-button">&times;</button>

    <!-- Modal Header -->
    <div class="modal-header">
      <div class="icon-container">
        <i class="fas fa-check-circle"></i>
      </div>
      <h2 class="modal-title">Program Registration Successful!</h2>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <p class="modal-text">
        🎉 Congratulations! Your program registration was successful. To
        finalize your registration, please complete your membership by filling
        out the <strong>Parent</strong>, <strong>Child</strong>, and
        <strong>Emergency</strong> information within
        <span class="highlight">48 hours</span>.
      </p>
      <p class="modal-text">⏳ Don't miss out on securing your spot!</p>
      <p class="modal-text disclaimer">
        <em
          >If you have already completed your membership profile, please ignore
          this message.</em
        >
      </p>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <a href="/all-membership" class="btn-primary">
        <i class="fas fa-user-check"></i> Go to All Membership
      </a>
    </div>
  </div>
</div>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
/>
